'use client';

import { ThemeProvider as NextThemeProvider } from 'next-themes';
import type { ReactNode } from 'react';

/**
 * Dark/light suit la préférence système par défaut.
 * Untitled UI déclare `@custom-variant dark (&:where(.dark-mode, .dark-mode *))` :
 * les classes doivent donc être `light-mode` / `dark-mode`, pas les valeurs par défaut
 * de next-themes.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      value={{ light: 'light-mode', dark: 'dark-mode' }}
    >
      {children}
    </NextThemeProvider>
  );
}
